import React from 'react';
import { useNavigate } from 'react-router-dom';

function Nav({ active }) {
  const navigate = useNavigate();

  return (
    <nav className="nav">
      <span className="nav-brand" onClick={() => navigate('/')}>inside me.</span>
      <div className="nav-links">
        <button className={`nav-link ${active === 'days' ? 'active' : ''}`} onClick={() => navigate('/days')}>
          days
        </button>
        <button className={`nav-link ${active === 'thoughts' ? 'active' : ''}`} onClick={() => navigate('/thoughts')}>
          thoughts
        </button>
      </div>
    </nav>
  );
}

export default Nav;
